<template>
  <div class="datepicker date-group-item">
    <el-button class="egl-btn-yellow date-group-btn" @click="reduceHandler">
      <i class="el-icon-arrow-left"></i>
    </el-button>
    <el-date-picker
      class="date-group-input"
      value-format="yyyy-MM-dd"
      format="yyyy-MM-dd"
      type="date"
      v-model="value"
      :placeholder="$locale('calendar.inputPlaceholder')"
      :clearable="false"
      @change="val => {changeHandler(val, idx, type);}"
      :picker-options="getDisType(idx, type)"
    />
    <el-button class="egl-btn-yellow date-group-btn" @click="plusHandler">
      <i class="el-icon-arrow-right"></i>
    </el-button>
  </div>
</template>
<script>

import moment from "moment";
export default {
  props: ["formItem", "idx", "type", "start", "end"],
  mounted() {
    this.value = moment(this.formItem).format("YYYY-MM-DD");
  },
  data() {
    return {
      value: new Date(),
      startDayOption: {
        disabledDate: this.disDate_start
      },
      endDayOption: {
        disabledDate: this.disDate_end
      },
    };
  },
  watch: {
    formItem(val) {
      this.value = moment(val).format("YYYY-MM-DD");
    }
  },
  methods: {
    changeHandler(val, idx, type) {
      this.$emit("change", val, idx, type);
    },
    disDate_start(time) {
      if (this.idx > 0) {
        let d = new Date(this.value);
        d.setDate(d.getDate() - 1);
        return time.getTime() < d || time.getTime() > new Date(this.end);
      }
      return time.getTime() > new Date(this.end);

    },
    disDate_end(time) {
      let d = new Date(this.start);
      d.setDate(d.getDate() - 1);
      return time.getTime() < new Date(d);
    },
    getDisType(idx, type) {
      if (type === "start") {
        return this.startDayOption;
      }
      return this.endDayOption;

    },
    plusHandler() {
      this.$emit("plusDate");
    },
    reduceHandler() {
      this.$emit("reduceDate");
    }
  }
};
</script>

<style scoped lang="less">
.date-group-item {
  display: inline-flex;
  width: 100%;
  max-width: 290px;
  height: 40px;

  .date-group-btn {
    width: 40px;
    height: 40px;
    padding: 0;
    line-height: 40px;
  }

  .date-group-input {
    flex: 1;
    height: 40px;
    padding: 0 10px;

    .el-input__prefix {
      left: auto;
      right: 20px;
    }

    .el-input__inner {
      width: 160px;
      padding-left: 15px;
      padding-right: 40px;
    }
  }
}
</style>
